const Maintenance = () => {
    return (
        <svg width="280" height="240" viewBox="0 0 280 240" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M140.506 239.415C217.334 239.415 279.616 237.68 279.616 235.54C279.616 233.399 217.334 231.664 140.506 231.664C63.6766 231.664 1.39453 233.399 1.39453 235.54C1.39453 237.68 63.6766 239.415 140.506 239.415Z"
                fill="#2E353A"
            />
            <path
                d="M210.98 232.007H198.109V0.0625L210.98 15.0283V232.007Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 177.393H210.858L198.23 165.188H210.858L198.23 177.393Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 164.878H210.858L198.23 152.672H210.858L198.23 164.878Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 202.311H210.858L198.23 190.105H210.858L198.23 202.311Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 189.799H210.858L198.23 177.594H210.858L198.23 189.799Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 152.366H210.858L198.23 140.16H210.858L198.23 152.366Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 139.854H210.858L198.23 127.648H210.858L198.23 139.854Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 127.339H210.858L198.23 115.133H210.858L198.23 127.339Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 114.827H210.858L198.23 102.621H210.858L198.23 114.827Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 102.315H210.858L198.23 90.1094H210.858L198.23 102.315Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 89.7995H210.858L198.23 77.5938H210.858L198.23 89.7995Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 77.2878H210.858L198.23 65.082H210.858L198.23 77.2878Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 64.7721H210.858L198.23 52.5664H210.858L198.23 64.7721Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 52.2604H210.858L198.23 40.0547H210.858L198.23 52.2604Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 39.7487H210.858L198.23 27.543H210.858L198.23 39.7487Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.23 27.2331H210.858L198.23 15.0273H210.858L198.23 27.2331Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M270.73 27.5701L264.494 23.6445H220.005L214.57 27.5701H270.73Z"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M271.758 27.2344H163.072V30.0945H271.758V27.2344Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M264.494 23.6445L198.109 0.0625L220.004 23.6445"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M198.109 0.0625L163.072 27.234"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M220.277 33.3125H193.463V50.4735H220.277V33.3125Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M220.277 215.191H193.463V232.352H220.277V215.191Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M214.685 36.8867H199.047V41.892H214.685V36.8867Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M271.76 30.0938V60.9263"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M275.843 71.4531H267.898V80.4555H275.843V71.4531Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M267.898 71.4516L271.867 60.3398L275.843 71.4516"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M165.876 213V197.098H119.005V213.014C118.997 218.209 117.233 223.249 113.999 227.315L111.947 229.904H172.904L170.845 227.315C167.624 223.239 165.873 218.195 165.876 213Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M116.123 224.148H168.757C166.875 220.734 165.891 216.898 165.897 213V197.098H119.005V213.014C119.002 216.91 118.01 220.74 116.123 224.148Z"
                fill="#145DA0"
            />
            <path
                d="M165.877 199.48H119.006V206.202H165.877V199.48Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M229.993 60.8125H54.8869C51.2182 60.8125 48.2441 63.7866 48.2441 67.4552V195.462C48.2441 199.13 51.2182 202.104 54.8869 202.104H229.993C233.662 202.104 236.636 199.13 236.636 195.462V67.4552C236.636 63.7866 233.662 60.8125 229.993 60.8125Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M48.2441 180.145H236.636V195.461C236.636 197.222 235.936 198.912 234.69 200.158C233.444 201.404 231.755 202.103 229.993 202.103H54.9226C53.1609 202.103 51.4712 201.404 50.2255 200.158C48.9797 198.912 48.2799 197.222 48.2799 195.461V180.145H48.2441Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M227.155 69.6094H57.7188V169.429H227.155V69.6094Z"
                fill="#145DA0"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M145.913 191.127C145.914 190.439 145.712 189.767 145.331 189.194C144.95 188.622 144.408 188.175 143.773 187.911C143.138 187.647 142.439 187.577 141.764 187.71C141.09 187.844 140.47 188.174 139.983 188.66C139.497 189.146 139.165 189.765 139.03 190.439C138.896 191.113 138.964 191.812 139.227 192.448C139.49 193.083 139.935 193.626 140.507 194.009C141.078 194.391 141.75 194.595 142.438 194.595C142.894 194.596 143.346 194.507 143.767 194.333C144.189 194.159 144.572 193.904 144.895 193.582C145.218 193.259 145.474 192.877 145.648 192.456C145.823 192.034 145.913 191.583 145.913 191.127Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M172.919 229.898H111.969V232.737H172.919V229.898Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M197.58 94.6242C199.543 92.6577 200.993 90.239 201.802 87.5808C202.612 84.9226 202.755 82.1063 202.221 79.3796L191.588 90.0122C190.984 90.613 190.167 90.9503 189.315 90.9503C188.462 90.9503 187.645 90.613 187.041 90.0122L178.203 81.1743C177.903 80.8754 177.666 80.5205 177.504 80.1297C177.342 79.7389 177.258 79.32 177.258 78.8969C177.258 78.4738 177.342 78.0549 177.504 77.6641C177.666 77.2734 177.903 76.9184 178.203 76.6195L188.828 65.994C185.85 65.4125 182.771 65.6407 179.912 66.655C177.052 67.6692 174.517 69.4323 172.571 71.7602C170.625 74.0881 169.34 76.8956 168.849 79.8897C168.358 82.8838 168.679 85.9548 169.78 88.7823L142.344 115.589L139.698 112.936L143.988 108.646C144.207 108.423 144.33 108.122 144.33 107.81C144.33 107.497 144.207 107.196 143.988 106.973L140.642 103.627C140.421 103.406 140.121 103.282 139.809 103.282C139.496 103.282 139.197 103.406 138.976 103.627L137.303 105.3L133.677 101.682L135.072 100.287C135.367 99.9911 135.532 99.59 135.532 99.1719C135.532 98.7537 135.367 98.3526 135.072 98.0564L105.133 68.1177C104.42 67.4034 103.573 66.8367 102.64 66.45C101.708 66.0634 100.708 65.8643 99.6986 65.8643C98.6891 65.8643 97.6896 66.0634 96.7571 66.45C95.8246 66.8367 94.9775 67.4034 94.2643 68.1177L91.2039 71.1781C90.4898 71.8907 89.9232 72.7372 89.5367 73.6691C89.1501 74.601 88.9512 75.5999 88.9512 76.6088C88.9512 77.6177 89.1501 78.6166 89.5367 79.5485C89.9232 80.4804 90.4898 81.3269 91.2039 82.0395L121.143 111.985C121.439 112.281 121.84 112.446 122.258 112.446C122.676 112.446 123.077 112.281 123.374 111.985L124.768 110.591L128.386 114.216L126.72 115.882C126.61 115.992 126.522 116.122 126.462 116.266C126.403 116.409 126.372 116.563 126.372 116.719C126.372 116.874 126.403 117.028 126.462 117.172C126.522 117.316 126.61 117.446 126.72 117.556L130.059 120.902C130.282 121.121 130.583 121.244 130.896 121.244C131.209 121.244 131.509 121.121 131.732 120.902L136.023 116.612L138.625 119.214L115.873 141.381C113.045 140.281 109.974 139.96 106.98 140.451C103.986 140.942 101.178 142.228 98.8498 144.173C96.5216 146.119 94.7578 148.653 93.7425 151.513C92.7272 154.372 92.4975 157.451 93.0773 160.429L103.71 149.804C104.009 149.504 104.364 149.267 104.755 149.105C105.145 148.943 105.564 148.859 105.987 148.859C106.41 148.859 106.829 148.943 107.22 149.105C107.611 149.267 107.966 149.504 108.265 149.804L117.131 158.585C117.431 158.883 117.668 159.238 117.83 159.629C117.992 160.02 118.076 160.439 118.076 160.862C118.076 161.285 117.992 161.704 117.83 162.095C117.668 162.485 117.431 162.84 117.131 163.139L106.506 173.765C109.484 174.345 112.563 174.117 115.422 173.102C118.282 172.088 120.817 170.325 122.763 167.998C124.709 165.67 125.995 162.863 126.488 159.869C126.98 156.876 126.66 153.805 125.562 150.976L148.314 128.81L179.34 159.8C178.894 160.949 178.792 162.203 179.046 163.409C179.3 164.615 179.899 165.721 180.77 166.593L188.256 174.079L197.237 165.091L189.751 157.612C188.879 156.741 187.773 156.142 186.567 155.888C185.361 155.634 184.107 155.736 182.958 156.182L151.982 125.206L179.447 98.4282C182.513 99.621 185.859 99.8965 189.079 99.2211C192.299 98.5457 195.252 96.9485 197.58 94.6242Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M123.675 147.164L177.539 94.6157C180.368 95.7179 183.442 96.0399 186.438 95.5481C189.435 95.0563 192.244 93.7688 194.573 91.82C196.902 89.8713 198.664 87.3328 199.676 84.47C200.689 81.6072 200.913 78.525 200.327 75.5456L189.702 86.1711C189.403 86.4705 189.048 86.7081 188.657 86.8702C188.266 87.0323 187.847 87.1157 187.424 87.1157C187.001 87.1157 186.582 87.0323 186.192 86.8702C185.801 86.7081 185.446 86.4705 185.147 86.1711L176.309 77.3332C176.01 77.035 175.772 76.6806 175.61 76.2904C175.448 75.9002 175.365 75.4819 175.365 75.0594C175.365 74.6369 175.448 74.2186 175.61 73.8284C175.772 73.4382 176.01 73.0838 176.309 72.7856L186.935 62.1529C183.955 61.5723 180.875 61.8022 178.014 62.8186C175.154 63.835 172.62 65.6007 170.675 67.9312C168.73 70.2617 167.447 73.0716 166.958 76.0675C166.47 79.0634 166.796 82.1354 167.9 84.9627L114.036 137.511C111.209 136.41 108.138 136.089 105.144 136.58C102.15 137.071 99.342 138.356 97.0141 140.302C94.6862 142.248 92.9231 144.783 91.9089 147.643C90.8946 150.502 90.6664 153.582 91.2479 156.56L101.873 145.934C102.172 145.635 102.527 145.397 102.918 145.235C103.309 145.073 103.728 144.99 104.151 144.99C104.574 144.99 104.993 145.073 105.384 145.235C105.774 145.397 106.129 145.635 106.428 145.934L115.266 154.772C115.565 155.07 115.803 155.425 115.965 155.815C116.127 156.205 116.21 156.623 116.21 157.046C116.21 157.468 116.127 157.887 115.965 158.277C115.803 158.667 115.565 159.021 115.266 159.32L104.619 169.931C107.597 170.511 110.676 170.283 113.536 169.268C116.395 168.254 118.93 166.491 120.876 164.164C122.822 161.836 124.109 159.029 124.601 156.035C125.093 153.042 124.774 149.971 123.675 147.143V147.164Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M119.528 141.649C119.116 141.236 118.885 140.677 118.885 140.094C118.885 139.511 119.116 138.952 119.528 138.539L167.957 91.4249C168.371 91.0127 168.932 90.7812 169.516 90.7812C170.1 90.7812 170.661 91.0127 171.075 91.4249C171.487 91.8389 171.719 92.3994 171.719 92.9836C171.719 93.5679 171.487 94.1284 171.075 94.5424L122.645 141.649C122.231 142.061 121.671 142.293 121.087 142.293C120.502 142.293 119.942 142.061 119.528 141.649Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M133.89 105.188L130.27 108.809L182.504 161.043L186.124 157.423L133.89 105.188Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M195.342 161.277L186.361 170.257L178.875 162.778C177.683 161.586 177.014 159.97 177.014 158.284C177.014 156.599 177.683 154.982 178.875 153.79C179.464 153.2 180.164 152.732 180.935 152.413C181.705 152.094 182.531 151.93 183.365 151.93C184.199 151.93 185.025 152.094 185.795 152.413C186.566 152.732 187.266 153.2 187.856 153.79L195.342 161.277Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M129.017 95.0197L120.104 103.934L127.344 111.174L136.258 102.26L129.017 95.0197Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M89.3267 67.308L92.3907 64.244C93.1038 63.5309 93.9504 62.9653 94.8821 62.5793C95.8139 62.1934 96.8125 61.9948 97.821 61.9948C98.8295 61.9948 99.8281 62.1934 100.76 62.5793C101.692 62.9653 102.538 63.5309 103.251 64.244L133.193 94.1862C133.488 94.4812 133.654 94.8814 133.654 95.2986C133.654 95.7158 133.488 96.1159 133.193 96.4109L121.494 108.111C121.199 108.406 120.798 108.571 120.381 108.571C119.964 108.571 119.564 108.406 119.269 108.111L89.3267 78.1685C87.8865 76.7283 87.0775 74.775 87.0775 72.7383C87.0775 70.7015 87.8865 68.7482 89.3267 67.308Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M137.092 99.7613L124.836 112.017C124.375 112.478 124.375 113.225 124.836 113.686L128.183 117.033C128.644 117.494 129.391 117.494 129.852 117.033L142.108 104.777C142.569 104.316 142.569 103.569 142.108 103.108L138.761 99.7613C138.3 99.3006 137.553 99.3006 137.092 99.7613Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M123.166 103.658L120.706 106.125L91.3037 76.7228C90.9767 76.3956 90.793 75.952 90.793 75.4894C90.793 75.0268 90.9767 74.5831 91.3037 74.2559C91.4653 74.0931 91.6574 73.9639 91.8691 73.8758C92.0808 73.7876 92.3079 73.7422 92.5372 73.7422C92.7665 73.7422 92.9936 73.7876 93.2053 73.8758C93.417 73.9639 93.6091 74.0931 93.7706 74.2559L123.166 103.658Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M127.364 99.4631L124.89 101.93L95.4873 72.5275C95.1603 72.2003 94.9766 71.7567 94.9766 71.2941C94.9766 70.8315 95.1603 70.3878 95.4873 70.0606C95.6488 69.8978 95.841 69.7686 96.0527 69.6804C96.2644 69.5923 96.4914 69.5469 96.7208 69.5469C96.9501 69.5469 97.1772 69.5923 97.3889 69.6804C97.6005 69.7686 97.7927 69.8978 97.9542 70.0606L127.364 99.4631Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M131.561 95.2638L129.087 97.7093L99.6846 68.3283C99.3576 68.0011 99.1738 67.5574 99.1738 67.0948C99.1738 66.6322 99.3576 66.1886 99.6846 65.8614C99.8461 65.6986 100.038 65.5694 100.25 65.4812C100.462 65.393 100.689 65.3477 100.918 65.3477C101.147 65.3477 101.374 65.393 101.586 65.4812C101.798 65.5694 101.99 65.6986 102.151 65.8614L131.561 95.2638Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M229.979 233.616H227.598L212.203 107.297H214.591L229.979 233.616Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M248.571 233.616H246.19L230.795 107.297H233.183L248.571 233.616Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M233.332 117.764H214.749L214.27 113.867H232.861L233.332 117.764Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M235.085 132.151H216.501L216.029 128.254H234.613L235.085 132.151Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M236.844 146.538H218.253L217.781 142.641H236.365L236.844 146.538Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M238.596 160.932H220.012L219.533 157.035H238.117L238.596 160.932Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M240.348 175.319H221.764L221.285 171.422H239.869L240.348 175.319Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M242.099 189.706H223.515L223.043 185.809H241.627L242.099 189.706Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M243.851 204.1H225.267L224.795 200.203H243.379L243.851 204.1Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path
                d="M245.61 218.487H227.019L226.547 214.59H245.131L245.61 218.487Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.127944"
                strokeMiterlimit="10"
            />
            <path d="M214.463 115.398H216.894" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M215.035 116.543H219.754" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M233.047 116.543H229.615" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M234.763 130.406H231.617" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M216.752 131.121H224.045" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M218.037 144.559H224.329" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M218.324 145.703H221.756" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M238.473 158.707H234.619" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M238.195 159.852H231.76" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M243.794 202.633H237.895" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M225.023 201.562H228.599" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M237.001 202.633H232.354" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M226.812 216.398H231.818" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M227.885 217.648H233.605" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M222.164 174.031H223.773" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path d="M239.682 173.676H233.783" stroke="#2E353A" strokeWidth="0.0639721" strokeMiterlimit="10" />
            <path
                d="M90.6536 158.086L87.822 161.776L26.2285 113.69L29.0672 110L90.6536 158.086Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.2285 158.086L29.0672 161.776L90.6536 113.69L87.822 110L26.2285 158.086Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M90.6536 212.101L88.9017 216.856L26.2285 167.704L28.0233 162.906L90.6536 212.101Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.2285 212.099L26.6575 217.676L90.6536 167.702L87.822 164.02L26.2285 212.099Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M27.6804 109.492H25.1777V233.623H27.6804V109.492Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M90.9968 109.492H88.4941V233.623H90.9968V109.492Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M78.6048 158.086L75.7661 161.776L14.1797 113.69L17.0112 110L78.6048 158.086Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1797 158.086L17.0112 161.776L78.6048 113.69L75.7661 110L14.1797 158.086Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M78.6048 212.101L76.8458 216.856L14.1797 167.704L15.0806 162.906L78.6048 212.101Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1797 212.099L14.6087 217.676L78.6048 167.702L75.7661 164.02L14.1797 212.099Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.6237 109.492H13.1211V233.623H15.6237V109.492Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M78.9421 109.492H76.4395V233.623H78.9421V109.492Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M82.1662 108.34H9.9043V112.273H82.1662V108.34Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M93.2991 108.34H73.2422V112.273H93.2991V108.34Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M82.1662 159.852H9.9043V163.784H82.1662V159.852Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M93.2991 159.852H73.2422V163.784H93.2991V159.852Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.140154"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M172.211 233.615H166.555L174.098 189.418H179.761L172.211 233.615Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.124455"
                strokeMiterlimit="10"
            />
            <path
                d="M183.53 233.615H189.193L181.642 189.418H175.986L183.53 233.615Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.124455"
                strokeMiterlimit="10"
            />
            <path
                d="M252.525 233.615H246.869L254.413 189.418H260.069L252.525 233.615Z"
                fill="#2E353A"
                stroke="#2E353A"
                strokeWidth="0.124455"
                strokeMiterlimit="10"
            />
            <path
                d="M263.844 233.615H269.508L261.957 189.418H256.301L263.844 233.615Z"
                fill="white"
                stroke="#2E353A"
                strokeWidth="0.124455"
                strokeMiterlimit="10"
            />
            <path
                d="M267.805 176.641H159.855V191.635H267.805V176.641Z"
                fill="#145DA0"
                stroke="#2E353A"
                strokeWidth="0.124455"
                strokeMiterlimit="10"
            />
            <path
                d="M270.436 176.641H162.486V191.635H270.436V176.641Z"
                fill="#145DA0"
                stroke="#2E353A"
                strokeWidth="0.124455"
                strokeMiterlimit="10"
            />
            <path d="M164.252 191.635H173.412L178.145 176.641H168.986L164.252 191.635Z" fill="#2E353A" />
            <path d="M200.52 176.641H191.353L186.619 191.635H195.786L200.52 176.641Z" fill="#2E353A" />
            <path d="M267.627 176.641H258.46L253.727 191.635H262.893L267.627 176.641Z" fill="#2E353A" />
            <path d="M245.253 176.641H236.093L231.359 191.635H240.519L245.253 176.641Z" fill="#2E353A" />
            <path d="M222.887 176.641H213.72L208.986 191.635H218.153L222.887 176.641Z" fill="#2E353A" />
            <path d="M269.842 183.301H251.98" stroke="#2E353A" strokeWidth="0.127944" strokeMiterlimit="10" />
            <path d="M269.528 185.801H266.711" stroke="#2E353A" strokeWidth="0.127944" strokeMiterlimit="10" />
            <path d="M162.029 185.18H179.891" stroke="#2E353A" strokeWidth="0.127944" strokeMiterlimit="10" />
            <path d="M162.336 182.355H184.903" stroke="#2E353A" strokeWidth="0.127944" strokeMiterlimit="10" />
        </svg>
    );
};
export default Maintenance;
